
import React from 'react'
import ReactDOM from 'react-dom/client'
import './animations.css'
import './index.css'
import './media.css'

import Desktop from './Desktop'
import DesktopContainer from './DesktopContainer'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<DesktopContainer />)
